import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { ImBullhorn } from "react-icons/im";
import { FaChartBar,FaBullhorn,FaUser,FaMobileAlt,FaWhatsapp,FaEnvelope,FaFileAlt,FaUsers  } from "react-icons/fa";


import fs from '../../MarketingImages/marketingoverview.jpeg';
import pm from '../../MarketingImages/personalisedmarketing.png';
import sms from '../../MarketingImages/smscampaign.jpeg';
import wa from '../../MarketingImages/whatsapp.png';
import em from '../../MarketingImages/email.png';
import mt from '../../MarketingImages/messagetemplate.jpeg';
import ms from '../../MarketingImages/customercontacts.jpeg';
import { useNavigate } from 'react-router-dom'


function Market() {
  const navigate = useNavigate();
  const marketingManagementCard = [{
    icon: <FaChartBar />,
    title: 'Elevate Your Marketing Strategy',
    sub: 'Efficiently manage campaigns, connect with customers, and drive engagement for marketing success.',
  }];


  
  const personalizedMarketingData = [
    {
      icon: <FaUser />,
      image: pm,
      iconTitle: 'Personalized Marketing',
      title: 'Tailor your marketing strategies to individual customer preferences and behaviors.',
      lines: [
        'Leverage data-driven insights for personalized campaigns.',
        'Create targeted promotions based on customer interactions.',
        'Enhance customer experience with personalized recommendations.'
      ],
    },
  ];
  
  const smsCampaignData = [
    {
      icon: <FaMobileAlt />,
      image: sms,

      iconTitle: 'SMS Campaign',
      title: 'Launch effective SMS campaigns to reach customers instantly and drive engagement.',
      lines: [
        'Efficiently manage and schedule SMS marketing campaigns.',
        'Personalize SMS content for a more engaging customer experience.',
        'Track SMS delivery, open rates, and overall campaign performance.'
      ],
    },
  ];
  
  const whatsappCampaignData = [
    {
      icon: <FaWhatsapp />,
      iconTitle: 'WhatsApp Campaign',
      image: wa,

      title: 'Connect with your audience through WhatsApp campaigns for a direct and personalized approach.',
      lines: [
        'Create and send targeted messages through WhatsApp.',
        'Optimize campaigns with multimedia content for better engagement.',
        'Analyze campaign metrics for continuous improvement.'
      ],
    },
  ];
  
  const emailCampaignData = [
    {
      icon: <FaEnvelope />,
      iconTitle: 'Email Campaign',
      image: em,
      title: 'Run successful email campaigns with personalized content and measurable results.',
      lines: [
        'Design and schedule email campaigns for optimal delivery.',
        'Segment and target email lists for more personalized communication.',
        'Analyze email campaign performance and adjust strategies accordingly.'
      ],
    },
  ];
  
  const messagingTemplatesData = [
    {
      icon: <FaFileAlt />,
      iconTitle: 'Messaging Templates',
      image: mt,
      title: 'Create reusable messaging templates for consistent and efficient communication.',
      lines: [
        'Build a library of templates for various marketing channels.',
        'Customize templates for different campaigns and purposes.',
        'Streamline content creation and maintain brand consistency.'
      ],
    },
  ];
  
  const customerContactsData = [
    {
      icon: <FaUsers />,
      iconTitle: 'Customer Contacts',
      image: ms,
      title: 'Organize and manage your customer contacts for targeted and effective marketing.',
      lines: [
        'Maintain a centralized database of customer contact information.',
        'Segment contacts based on demographics, behaviors, and preferences.',
        'Enhance personalized marketing by leveraging accurate customer data.'
      ],
    },
  ];
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <ImBullhorn className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Campaign Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-5   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'> Personalize, Engage<br /> Your Marketing Evolution.</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[19px] leading-[26px] lg:leading-[36px]  '>Tailor campaigns to individual preferences, launch instant SMS and WhatsApp campaigns, and run successful email marketing. Dive into personalized marketing, optimize campaigns with reusable templates, and seamlessly organize customer contacts. With data-driven insights and a centralized approach, elevate your marketing game to new heights.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')}  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className='  w-full lg:w-[50%]'>
     <img className=' rounded-2xl aspect-auto' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
        <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
<span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does campaign management matter?</span>
<div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
 {marketingManagementCard?.map((e) => (
    <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
    <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
    <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
        
         <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
    </div>
 ))}
   

</div>
</div>
  {/* 4th Section */}
  <PageSection bg  data={personalizedMarketingData} />

  <PageSection reverse  data={smsCampaignData} />
  {/* <Clients /> */}


  <PageSection   data={whatsappCampaignData} />


  <PageSection bg  data={emailCampaignData} />

  <PageSection reverse  data={messagingTemplatesData} />
  <Branding />


  <PageSection   data={customerContactsData} />







  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Market
